import { render, staticRenderFns } from "./RanksModal.vue?vue&type=template&id=1e257b2a&scoped=true&"
import script from "./RanksModal.vue?vue&type=script&lang=js&"
export * from "./RanksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e257b2a",
  null
  
)

export default component.exports